const ROLES = {
  ADMIN: 1,
  AUDIENCE_ACTIVATION: 2,
}

export default class Roles {
  constructor(roles) {
    this.roles = {}
    if (roles) {
      this.setRoles(roles)
    }
  }

  setRoles(roles) {
    this.roles = {}
    for (let r of roles) {
      this.roles[r] = true
    }
  }

  hasAdminRole() {
    return this.roles[ROLES.ADMIN]
  }

  hasAudienceActivationProfile() {
    return this.roles[ROLES.AUDIENCE_ACTIVATION]
  }
}



// WEBPACK FOOTER //
// ./src/app/store/modules/auth/Roles.js